<template>
  <div class="container">
    <div class="columns">
      <div class="column is-12">
        <section class="hero is-white is-small">
          <div class="hero-body">

            <template v-if="loading.completed && results.length === 0">
              <b-message>
                スコアリングの結果はありません
              </b-message>
            </template>

            <template v-else>
              <b-message title="結果の評価について" size="is-small" type="is-info" :active.sync="isTipsActive">
                <b>【AUC】</b><br>
                予測値の順に並べたときに、結果データの「0 or 1」がどれだけ一方に依っているかを数値化したもので、0.5～1.0の値をとります。<br>
                0.7以上で優良なモデルと言われます。<br>
                <br>
                <b>【KS】</b><br>
                予測値順に並べたときに、実際に1であった集団と、0であった集団の分布の離れ具合を示す指標です。<br>
                より離れているほど確実に分類できています。<br>
                一般に、0.3以上が目安と言われます。<br>
                <br>
                <b>【Precision】</b><br>
                モデルによる予測結果の適合率とは、予測で「1」と判断したものの内、実際に「1」であったものの割合で、数値が高いほど良いモデルと言えます。<br>
                予測結果の信頼度を重視する場合に注目します。<br>
                <br>
                <b>【Recall】</b><br>
                モデルによる予測結果による再現率とは、実際に「1」であったものの内、「1」と予測できたものの割合で、数値が高いほど良いモデルと言えます。<br>
                予測結果に漏れがないかを重視する場合に注目します。<br>
              </b-message>

              <div class="b-table">
                <div class="table-wrapper">
                  <table class="table has-mobile-cards">
                    <thead>
                    <tr>
                      <th style="width: 1rem;"></th>
                      <th style="max-width: 24rem;">
                        <div class="th-wrap">アップロードファイル</div>
                      </th>
                      <th>
                        <div class="th-wrap">実行モデル</div>
                      </th>
                      <th>
                        <div class="th-wrap align-center">実行件数<br>(評価済)</div>
                      </th>
                      <th>
                        <div class="th-wrap align-center">実行日時 </div>
                      </th>
                      <th><div class="th-wrap">結果</div></th>
                      <th>
                        <div class="th-wrap">結果の評価
                          <span v-show="loading.completed && results.length > 0" @click="isTipsActive = !isTipsActive"
                                class="icon has-text-info is-small is-pointer"><i class="fas fa-question-circle"></i>
                          </span>
                        </div>
                      </th>
                      <th></th>
                    </tr>
                    </thead>

                    <tbody>
                      <template v-for="(row, index) in results">
                        <tr>
                          <td>
                            <a v-if="row.meta.bundle && row.status === 'COMPLETE'" role="button" @click="toggleDetailRow(index)">
                              <span class="icon is-expanded"><i class="fas fa-angle-right fa-lg"></i></span>
                            </a>
                            <b-tooltip v-else-if="row.status === 'RUNNING'"
                                       label="クリックで再読み込み"
                                       type="is-light"
                                       position="is-top">
                              <div @click="loadResults">
                                <b-tag class="tag is-dark is-pointer">実行中</b-tag>
                              </div>
                            </b-tooltip>

                            <b-tag v-else-if="row.status === 'FAILURE'" closable @close="deleteScore(row)" class="tag is-danger">失敗</b-tag>
                          </td>

                          <td>
                            <span>{{ row.meta.original_file_name }}</span>
                          </td>

                          <td>
                            <span>{{ row.meta.model.name }}</span>
                          </td>

                          <td class="align-center">
                            <span>
                              {{ row.meta.data_length ? row.meta.data_length : '-' }}<br>
                              ({{ row.meta.evaluation.data_length ? row.meta.evaluation.data_length : '-' }})
                            </span>
                          </td>

                          <td>
                            <span class="tag is-light date-tag">{{ row.created.replace(' ', '\n') }}</span>
                          </td>

                          <td>
                            <span v-if="row.status === 'COMPLETE'" class="icon is-medium has-text-primary active"
                                  @click="downloadCSV(row.transaction_id)">
                              <i class="fas fa-lg fa-file-download"></i>
                            </span>
                            <span v-else class="icon is-medium has-text-grey">
                              <i class="fas fa-lg fa-file-download"></i>
                            </span>
                          </td>

                          <td>
                            <table class="table evaluation" :class="{hidden: row.meta.bundle}">
                              <thead>
                                <tr>
                                  <th :class="{evaluated: row.meta.evaluation.data_length}">AUC</th>
                                  <th :class="{evaluated: row.meta.evaluation.data_length}">KS</th>
                                  <th :class="{evaluated: row.meta.evaluation.data_length}">Precision</th>
                                  <th :class="{evaluated: row.meta.evaluation.data_length}">Recall</th>
                                  <th :class="{evaluated: row.meta.evaluation.data_length}"></th>
                                </tr>
                              </thead>
                              <tbody>
                              <tr>
                                <td>
<!--                                  <b-tooltip v-if="row.meta.evaluation.AUC" label="「非常に良い」結果です"-->
<!--                                             position="is-bottom"-->
<!--                                             type="is-info">-->
<!--                                    <span>{{ floorForDisplay(row.meta.evaluation.AUC.score) }}</span>-->
<!--                                  </b-tooltip>-->
                                  <span v-if="row.meta.evaluation.AUC">{{ floorForDisplay(row.meta.evaluation.AUC.score) }}</span>
                                  <span v-else>-</span>
                                </td>
                                <td>
<!--                                  <b-tooltip v-if="row.meta.evaluation.KS" label="「良い」結果です" position="is-bottom"-->
<!--                                             type="is-success">-->
<!--                                    <span>{{ floorForDisplay(row.meta.evaluation.KS.score) }}</span>-->
<!--                                  </b-tooltip>-->
                                  <span v-if="row.meta.evaluation.KS">{{ floorForDisplay(row.meta.evaluation.KS.score) }}</span>
                                  <span v-else>-</span>
                                </td>
                                <td>
<!--                                  <b-tooltip v-if="row.meta.evaluation.Precision" label="「あまり良くない」結果です"-->
<!--                                             position="is-bottom"-->
<!--                                             type="is-warning">-->
<!--                                    <span>{{ floorForDisplay(row.meta.evaluation.Precision.score) }}</span>-->
<!--                                  </b-tooltip>-->
                                  <span v-if="row.meta.evaluation.Precision">{{ floorForDisplay(row.meta.evaluation.Precision.score) }}</span>
                                  <span v-else>-</span>
                                </td>
                                <td>
<!--                                  <b-tooltip v-if="row.meta.evaluation.Recall" label="「非常に良くない」結果です"-->
<!--                                             position="is-bottom"-->
<!--                                             type="is-danger">-->
<!--                                    <span>{{ floorForDisplay(row.meta.evaluation.Recall.score) }}</span>-->
<!--                                  </b-tooltip>-->
                                  <span v-if="row.meta.evaluation.Recall">{{ floorForDisplay(row.meta.evaluation.Recall.score) }}</span>
                                  <span v-else>-</span>
                                </td>
                                <td>
                                  <b-tooltip v-if="row.meta.evaluation.Compare"
                                             label="グラフを表示"
                                             position="is-bottom"
                                             type="is-primary">
                                    <span class="icon is-medium has-text-primary active"
                                          @click="showChart(row.meta.evaluation.Compare)">
                                      <i class="fas fa-lg fa-chart-bar"></i>
                                    </span>
                                  </b-tooltip>
                                  <span v-else class="icon is-medium has-text-grey-light">
                                    <i class="fas fa-lg fa-chart-bar"></i>
                                  </span>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </td>
                          <td>
                            <b-dropdown v-if="row.status === 'COMPLETE'" position="is-bottom-left">
                              <b-icon
                                pack="fas"
                                icon="ellipsis-h"
                                slot="trigger"
                                :class="'is-pointer'">
                              </b-icon>
                              <b-dropdown-item @click="evaluateScore(row.transaction_id)">
                                <span class="icon"><i class="fas fa-check-circle" aria-hidden="true"></i></span>
                                <span>スコア評価</span>
                              </b-dropdown-item>
                              <b-dropdown-item @click="previewScore(row.transaction_id)">
                                <span class="icon"><i class="fas fa-list-alt" aria-hidden="true"></i></span>
                                <span>プレビュー</span>
                              </b-dropdown-item>
                              <b-dropdown-item @click="deleteScore(row)">
                                <span class="icon"><i class="fas fa-trash" aria-hidden="true"></i></span>
                                <span class="has-text-danger">削除</span>
                              </b-dropdown-item>
                            </b-dropdown>
                          </td>
                        </tr>

                        <tr v-if="row.meta.bundle" v-show="visibleDetailRows.includes(index)" class="detail">
                          <td colspan="7">
                            <div class="detail-container">
                              <table class="table has-mobile-cards">
                                <thead>
                                <tr>
                                  <th width="40px"><!-- spacer --></th>
                                  <th>
                                    <div class="th-wrap">実行モデル</div>
                                  </th>
                                  <th>
                                    <div class="th-wrap">結果の評価</div>
                                  </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="model in row.meta.bundle">
                                  <td><!-- spacer --></td>
                                  <td>
                                    <span>{{ model.name }}</span>
                                  </td>
                                  <td>
                                    <table class="table evaluation">
                                      <thead>
                                      <th :class="{evaluated: row.meta.evaluation.data_length}">AUC</th>
                                      <th :class="{evaluated: row.meta.evaluation.data_length}">KS</th>
                                      <th :class="{evaluated: row.meta.evaluation.data_length}">Precision</th>
                                      <th :class="{evaluated: row.meta.evaluation.data_length}">Recall</th>
                                      <th :class="{evaluated: row.meta.evaluation.data_length}"></th>
                                      </thead>
                                      <tbody>
                                      <tr>
                                        <td>
<!--                                          <b-tooltip v-if="row.meta.evaluation.data_length" label="「非常に良い」結果です"-->
<!--                                                     position="is-bottom"-->
<!--                                                     type="is-info">-->
<!--                                            <span>{{ floorForDisplay(row.meta.evaluation[model.id].AUC.score) }}</span>-->
<!--                                          </b-tooltip>-->
                                          <span v-if="row.meta.evaluation.data_length">{{ floorForDisplay(row.meta.evaluation[model.id].AUC.score) }}</span>
                                          <span v-else>-</span>
                                        </td>
                                        <td>
<!--                                          <b-tooltip v-if="row.meta.evaluation.data_length" label="「良い」結果です" position="is-bottom"-->
<!--                                                     type="is-success">-->
<!--                                            <span>{{ floorForDisplay(row.meta.evaluation[model.id].KS.score) }}</span>-->
<!--                                          </b-tooltip>-->
                                          <span v-if="row.meta.evaluation.data_length">{{ floorForDisplay(row.meta.evaluation[model.id].KS.score) }}</span>
                                          <span v-else>-</span>
                                        </td>
                                        <td>
<!--                                          <b-tooltip v-if="row.meta.evaluation.data_length" label="「あまり良くない」結果です"-->
<!--                                                     position="is-bottom"-->
<!--                                                     type="is-warning">-->
<!--                                            <span>{{ floorForDisplay(row.meta.evaluation[model.id].Precision.score) }}</span>-->
<!--                                          </b-tooltip>-->
                                          <span v-if="row.meta.evaluation.data_length">{{ floorForDisplay(row.meta.evaluation[model.id].Precision.score) }}</span>
                                          <span v-else>-</span>
                                        </td>
                                        <td>
<!--                                          <b-tooltip v-if="row.meta.evaluation.data_length" label="「非常に良くない」結果です"-->
<!--                                                     position="is-bottom"-->
<!--                                                     type="is-danger">-->
<!--                                            <span>{{ floorForDisplay(row.meta.evaluation[model.id].Recall.score) }}</span>-->
<!--                                          </b-tooltip>-->
                                          <span v-if="row.meta.evaluation.data_length">{{ floorForDisplay(row.meta.evaluation[model.id].Recall.score) }}</span>
                                          <span v-else>-</span>
                                        </td>
                                        <td>
                                          <b-tooltip v-if="row.meta.evaluation.data_length"
                                                     label="グラフを表示"
                                                     position="is-bottom"
                                                     type="is-primary">
                                            <span class="icon is-medium has-text-primary active"
                                                  @click="showChart(row.meta.evaluation[model.id].Compare)">
                                              <i class="fas fa-lg fa-chart-bar"></i>
                                            </span>
                                          </b-tooltip>
                                          <span v-else class="icon is-medium has-text-grey-light">
                                            <i class="fas fa-lg fa-chart-bar"></i>
                                          </span>
                                        </td>
                                      </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </template>

          </div>
        </section>
      </div>
    </div>

    <evaluate-modal :isModalActive="evaluation.isModalActive"
                    :transactionId="evaluation.transactionId"/>

    <score-modal :isModalActive="result.isModalActive"
                 :model="result.model"
                 :scores="result.scores"
                 :columns="result.columns"
                 :cancel="true"/>

    <chart-modal :predActualData="chart.predActual"
                 :capData="chart.cap"
                 :isModalActive="chart.isModalActive"/>


    <b-loading :is-full-page="loading.isFullPage"
               :active.sync="loading.isActive"
               :can-cancel="false"></b-loading>
  </div>


</template>

<script>

import BTableColumn from 'buefy/src/components/table/TableColumn'
import BField from 'buefy/src/components/field/Field'

import EvaluateModal from '../components/EvaluateModal'
import ScoreModal from '../components/ScoreModal'
import ChartModal from '../components/ChartModal'

import {resultsRequest, signatureRequest, previewRequest, deleteRequest} from '../modules/request/results'

export default {
  name: 'Results',
  components: {
    BField,
    BTableColumn,
    'evaluate-modal': EvaluateModal,
    'score-modal': ScoreModal,
    'chart-modal': ChartModal
  },
  data () {
    return {
      isTipsActive: false,
      visibleDetailRows: [],
      results: [],
      previews: {},
      result: {
        model: '',
        scores: [],
        columns: [],
        isModalActive: false
      },
      loading: {
        isFullPage: true,
        isActive: false,
        completed: false
      },
      evaluation: {
        transactionId: '',
        isModalActive: false
      },
      chart: {
        predActual: {},
        cap: {},
        isModalActive: false
      }
    }

  },
  methods: {
    loadResults () {
      resultsRequest(this)
    },
    evaluateScore (transactionId) {
      this.evaluation.transactionId = transactionId
      this.evaluation.isModalActive = true
    },
    async previewScore (transactionId) {

      if (this.previews.hasOwnProperty(transactionId)) {
        this.preview(this.previews[transactionId], this)
        return
      }

      let param = {
        preview_limit: 10
      }

      this.loading.isActive = true
      const response = await previewRequest(transactionId, param, this)

      this.previews[transactionId] = response
      this.preview(response)
    },
    preview (response) {
      let result = this.result
      const data = response.data

      result.model = response.model_id
      result.scores = data.scores

      let columns = []

      for (let i in data.columns) {
        let columnName = data.columns[i]
        columns.push({field: columnName, label: columnName})
      }

      this.loading.isActive = false
      result.columns = columns
      result.isModalActive = true
    },
    downloadCSV (transactionId) {
      signatureRequest(transactionId, this.$parent)
    },
    deleteScore (row) {
      let $parent = this
      this.$dialog.confirm({
        title: 'スコア削除',
        message: `ファイル名：<b>${row.meta.original_file_name}</b>
                <br>実行モデル：<b>${row.meta.model.name}</b>
                <br>実行日時：<b>${row.created}</b>
                <br><br>こちらのスコアを削除します。よろしいですか？`,
        cancelText: 'キャンセル',
        confirmText: '削除',
        type: 'is-danger',
        hasIcon: true,
        onConfirm () {
          $parent.loading.isActive = true
          deleteRequest(row.transaction_id, $parent)
        }
      })
    },
    toggleDetailRow (indexAsKey) {
      if (this.visibleDetailRows.includes(indexAsKey)) {
        let index = this.visibleDetailRows.indexOf(indexAsKey)
        this.visibleDetailRows.splice(index, 1)
      } else {
        this.visibleDetailRows.push(indexAsKey)
      }
    },
    showChart (compareData) {
      this.chart.predActual = compareData.predict_actual
      this.chart.cap = compareData.cap
      this.chart.isModalActive = true
    },
    floorForDisplay (value) {
      return Math.floor(value * 100) / 100
    }
  },
  mounted () {
    this.loadResults()
  }
}
</script>

<style scoped>

  .icon.is-medium.active {
    cursor: pointer;
  }

  table td {
    vertical-align: middle;
    font-size: 0.9rem;
    max-width: 24rem;
  }

  .table.evaluation td, .table.evaluation th {
    width: 2.5rem;
    text-align: center;
    font-size: 0.8rem;
  }

  .table.evaluation th {
    background: #f5f5f5;
    color: #363636;
    padding: 0.2rem;
    width: 3rem;
  }
  .table.evaluation th.evaluated {
    background: #7957d5;
    color: #fff;
  }

  .table.evaluation td {
    background: #f5f5f5;
    color: #363636;
    padding: 0;
  }

  .table.evaluation.hidden {
    visibility: hidden;
  }

  .align-center {
    text-align: center;
  }

  .is-pointer {
    cursor: pointer !important;
  }

  .detail-container > table {
    padding: 1rem;
  }

  table thead th {
    border-width: 0 0 2px !important;
  }

  .date-tag {
    height: auto;
    text-align: center;
    white-space:pre-wrap;
    word-wrap:break-word;
  }

</style>



// WEBPACK FOOTER //
// src/views/Results.vue